"use strict";
const { parse } = require('./stringParser');
const { ARRAY_OF_STRING, STRING, } = require('../../../definitions/operandValueTypes');
exports.accepts = ({ valueType }) => valueType === ARRAY_OF_STRING;
exports.parse = ({ value }) => {
    // Send all items through the string parser
    // to ensure they receive the same parsing as non-array string values.
    const parsedStringArray = value.map((item) => parse({
        valueType: STRING,
        value: item,
    }));
    return parsedStringArray;
};
//# sourceMappingURL=arrayOfStringParser.js.map